module.exports = __webpack_public_path__ + "c0cb606f4b959b14e9fe847817039b9d.MP3";